/**
 * The note gate lives on the server (services/note_gate.py). The browser
 * asks it — through /observations/notes/check/ as a field is left, and on
 * every save — and shows what it says. There is no copy of the rules here,
 * so the two can never disagree.
 */

/** The gate result a refused save or a check came back with, or null. */
export function gateFromError(err) {
  const gate = err?.response?.data?.gate;
  return gate && typeof gate.label === 'string' ? gate : null;
}

/** The fields the gate reads, as the API names them. */
export function gatePayload({ evidence, impact, who, identifier }) {
  return {
    evidence_text: evidence || '',
    impact_text: impact || '',
    student_group: who || '',
    student_identifier: identifier || '',
  };
}
